let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("f5GLt")).then(() => parcelRequire('iRY9Q'));